import React, { useState, useEffect, useContext, Fragment, useCallback, useRef } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { RiContactsLine } from 'react-icons/ri';
import { ObjModal } from '../../../contexts';
import SendTxt from '../../Modals/SendTxt';
import SendEmail from '../../Modals/SendEmail';
import ClaimPartner from '../../Modals/ClaimPartner';
import RefiSnooze from '../../Modals/RefiSnooze';
import { MdContentCopy } from 'react-icons/md';
import BusinessIcon from '@mui/icons-material/Business';
import TaskIcon from '@mui/icons-material/Task';
import PaidIcon from '@mui/icons-material/Paid';
import OfflineBoltIcon from '@mui/icons-material/OfflineBolt';
import NoteIcon from '@mui/icons-material/Note';
import StarsIcon from '@mui/icons-material/Stars';
import RedeemIcon from '@mui/icons-material/Redeem';
import MergeIcon from '@mui/icons-material/Merge';
import DeleteIcon from '@mui/icons-material/Delete';
import AddTaskFollowUp from '../../Modals/AddTaskFollowUp';
import RemoveContact from '../../Modals/RemoveContact';
import LogComms from '../../Modals/LogComms';
import GenPALetter from '../../Modals/GenPALetter';
import { update, createLetter, createNote } from '../../../common/api';
import { generatePdf, render } from '../../../common/utils';
import { toast } from 'react-toastify';
import MergeContacts from '../../Modals/MergeContacts';
import Handlebars from 'handlebars/dist/cjs/handlebars';
import ExtraFields from '../../Modals/ExtraFields';
import { CommsPanelCtx } from '../../../contexts';


const Header = ( { user, org, orgId, aid, uid, role, settings, layout, contacts, loans } ) => {
    const { obj, objType, openModal, closeModal, setModal, getDraftValue, extraFields, setExtraReady } = useContext( ObjModal );
    
    const [ view, setView ] = useState( [] );
    const [ hasButtons, setHasButtons ] = useState( false );
    const [ hasDropdown, setHasDropdown ] = useState( false );
    const [ hasFields, setHasFields ] = useState( false );
    const [ title, setTitle ] = useState( '' );
    const [ allTmpls, setAllTmpls ] = useState( {} );
    const [ showHomebot, setShowHomebot ] = useState( false );

    const { addPanel, closePanel } = useContext( CommsPanelCtx );

    // useRef is necessary to handle the extraField values when the 2nd modal is rendered
    const handleClickRef = useRef();
    const handleModalRef = useRef();
    const handleActionRef = useRef();

    const formatDate = ( date ) => {
        let year = date.getFullYear().toString().substr( -2 );
        let month = ( date.getMonth() + 1 ).toString();
        let day = date.getDate().toString();
    
        // Ensure double digit format
        month = month.length === 1 ? '0' + month : month;
        day = day.length === 1 ? '0' + day : day;
    
        return `${month}/${day}/${year}`;
    };

    const handleClick = useCallback( async ( b ) => {
        switch ( b.modal ) {
            case 'email':
                if ( settings && settings.emailPanels === true ) {
                    if ( handleActionRef.current ) {
                        await handleActionRef.current( b );
                    }
                } else {
                    if ( handleModalRef.current ) {
                        await handleModalRef.current( b );
                    }
                }
                break;

            case 'sms':
            case 'task-followup':
            case 'log-call':
            case 'log-email':
            case 'log-sms':
            case 'remove-contact':
            case 'remove-dup-contact':
            case 'merge-contacts':
            case 'claim':
            case 'gen-pa-letter':
            case 'multiple':
            case 'extra.multiple':
            case 'extra.gen-pdf':
            case 'refi-snooze':
                if ( handleModalRef.current ) {
                    await handleModalRef.current( b );
                }
                break;

            case 'task-complete':
            case 'task-cancelled':
            case 'task-reopen':
            case 'task-skip':
            case 'submit-setup':
            case 'submit-review':
            case 'release-claim':
            case 'gen-pdf':
            case 'intake-purch-reset':
            case 'intake-refi-reset':
                if ( handleActionRef.current ) {
                    await handleActionRef.current( b );
                }
                break;

            default:
                console.log( 'Unknown click type: ' + b.modal );
        }
    }, [ settings ] );
    handleClickRef.current = handleClick;
    
    const handleModal = useCallback( async ( b ) => {
        const [ pri, sub ] = b.modal.split( '.' );
        const template = b.template;

        let o = obj;
        let oType = objType;

        console.log( 'button: ', b );
        if ( b.related ) {
            console.log( 'related: ', b.related );
            switch ( b.related ) {
                case 'contact':
                    if ( obj.associations && obj.associations.length ) {
                        const ta = obj.associations[0];
                        if ( ta && contacts[ta.cid] ) {
                            const c = contacts[ta.cid];
                            console.log( 'contact: ', c );
                            oType = 'contact';
                            o = c;
                            o.details = c;
                        }
                    }
                    break;

                case 'loan':
                    console.log( 'loan: ', obj );
                    if ( obj.associations && obj.associations.length ) {
                        const ta = obj.associations[0];
                        if ( ta && loans[ta.lid] ) {
                            const l = loans[ta.lid];
                            console.log( 'loan: ', l );
                            oType = 'loan';
                            o = l;
                            o.details = l;
                        }
                    }
                    break;

                default:
                    console.log( 'Unknown related type: ' + b.related );
            }
        }

        switch ( pri ) {
            case 'email':
                setModal( <SendEmail close={closeModal} tmpl={template} obj={o.details} objType={oType} extraFields={extraFields} /> ); 
                break;

            case 'sms':
                setModal( <SendTxt close={closeModal} tmpl={template} obj={o.details} objType={oType} /> );
                break;

            case 'task-followup':
                setModal( <AddTaskFollowUp close={closeModal} copy={obj} /> );
                break;

            case 'log-call':
                setModal( <LogComms commType='Call' close={closeModal} cid={obj.details.cid} /> );
                break;

            case 'log-email':
                setModal( <LogComms commType='Email' close={closeModal} cid={obj.details.cid} /> );
                break;

            case 'log-sms':
                setModal( <LogComms commType='Txt' close={closeModal} cid={obj.details.cid} /> );
                break;

            case 'remove-contact':
                setModal( <RemoveContact close={closeModal} c={obj.details} /> );
                break;

            case 'remove-dup-contact':
                setModal( <RemoveContact close={closeModal} c={ contacts[b.dupCid] } /> );
                break;

            case 'merge-contacts':
                setModal( <MergeContacts close={closeModal} pri={obj.details} sec={contacts[b.dupCid]} /> );
                break;

            case 'claim':
                setModal( <ClaimPartner close={closeModal} c={obj} /> );
                break;

            case 'refi-snooze':
                setModal( <RefiSnooze close={closeModal} l={o} /> );
                break;

            case 'gen-pa-letter':
                let cid;
                if ( obj.details.borrowers ) {
                    cid = obj.details.borrowers[0].cid;
                }
                setModal( <GenPALetter close={closeModal} aid={obj.details.aid} cid={cid} lid={obj.details.lid} /> );
                break;

            case 'multiple':
                let file;
                if ( template.pdf ) {
                    const t = allTmpls[template.pdf];
                    if ( !t ) {
                        console.log( 'Missing pdf template - aborting' );
                        return;
                    }
                    console.log( 'create pdf...', extraFields );
                    const params = {
                        user: user,
                        org: org,
                        extra: { ...extraFields }
                    };

                    if ( oType === 'contact' ) {
                        params.contact = {
                            ...o,
                            referredBy: contacts[o.referredById]
                        }
                    } else if ( oType === 'loan' ) {
                        const pri = o.borrowers.find( f => f.label === 'Primary' );
                        const c = contacts[pri.cid];
                        const lp2 = user.lists.team.find( f => f.uid === o.lp2 );
                        params.contact = {
                            ...c,
                            referredBy: contacts[c.referredById]
                        };
                        params.loan = {
                            ...o,
                            buyersAgent: contacts[o.baId],
                            buyersAgentTC: contacts[o.baTcId],
                            listingAgent: contacts[o.laId],
                            listingAgentTC: contacts[o.laTcId],
                            escrow: contacts[o.escrowOfficerId],
                            title: contacts[o.titleRepId],
                            lp2rep: lp2
                        };
                    }

                    const objAccount = user.lists.accounts.find( f => f.id === obj.details.aid );
                    if ( objAccount && objAccount.owner ) {
                        params.owner = user.lists.team.find( f => f.uid === objAccount.owner );
                    }

                    console.log( 'pdf params: ', params );
                    file = await generatePdf( obj.details.aid, uid, template.filename, t.body, params, true, contacts );
                }
                if ( template.email ) {
                    setModal( <SendEmail close={closeModal} tmpl={template.email} obj={o.details} objType={oType} attachment={file} extraFields={extraFields} /> ); 
                }
                break;

            case 'extra':
                console.log( 'extra!', b.extraFields );
                setExtraReady( false );
                const newButton = {
                    ...b,
                    modal: sub
                }
                setModal( <ExtraFields close={closeModal} extra={b.extraFields} nextStep={ () => {
                    if ( handleClickRef.current ) {
                        handleClickRef.current( newButton );
                    }
                } } /> );
                break;

            default:
                console.log( 'Unknown modal type: ' + b.modal );
                return;
        }

        openModal();
    }, [ extraFields, org, uid, user, allTmpls, openModal, closeModal, setModal, contacts, loans, handleClickRef, obj, objType, setExtraReady ] );
    handleModalRef.current = handleModal;

    const handleAction = useCallback( async ( b ) => {
        const at = b.modal;
        const action = b.action;
        const template = b.template;
        let updated;
        let u;
        let outcome;

        let o = obj;
        let oType = objType;

        console.log( 'button: ', b );
        if ( b.related ) {
            console.log( 'related: ', b.related );
            switch ( b.related ) {
                case 'contact':
                    if ( obj.associations && obj.associations.length ) {
                        const ta = obj.associations[0];
                        if ( ta && contacts[ta.cid] ) {
                            const c = contacts[ta.cid];
                            console.log( 'contact: ', c );
                            oType = 'contact';
                            o = c;
                            o.details = c;
                        }
                    }
                    break;

                case 'loan':
                    console.log( 'loan: ', obj );
                    if ( obj.associations && obj.associations.length ) {
                        const ta = obj.associations[0];
                        if ( ta && loans[ta.lid] ) {
                            const l = loans[ta.lid];
                            console.log( 'loan: ', l );
                            oType = 'loan';
                            o = l;
                            o.details = l;
                            console.log( 'o: ', o );
                        }
                    }
                    break;

                default:
                    console.log( 'Unknown related type: ' + b.related );
            }
        }

        switch ( at ) {
            case 'email':
                addPanel( { obj: o.details, objType: oType, panelType: 'email', tmpl: template } )
                break;

            case 'task-complete':
                u = {
                    status: 'Completed', 
                    completedDate: new Date().toJSON()
                };
                outcome = getDraftValue( 'outcome' );
                if ( outcome ) {
                    console.log( 'setting outcome to: ' + outcome );
                    u.outcome = outcome;
                }
                updated = await update( orgId, obj.details.aid, uid, 'task', obj.details.tid, u );
                if ( updated.length ) {
                    toast.success( `The task has been marked complete - nice work!`, { theme: 'dark' } );
                    // window.location.reload( false );
                }
                break;

            case 'task-cancelled':
                u = {
                    status: 'Cancelled', 
                    cancelledDate: new Date().toJSON()
                };
                outcome = getDraftValue( 'outcome' );
                if (  outcome ) {
                    console.log( 'setting outcome to: ' + outcome );
                    u.outcome = outcome;
                }
                updated = await update( orgId, obj.details.aid, uid, 'task', obj.details.tid, u );
                if ( updated.length ) {
                    toast.success( `The task has been marked cancelled - nice work!`, { theme: 'dark' } );
                    // window.location.reload( false );
                }
                break;
    
            case 'task-skip':
                u = {
                    status: 'Not Doing', 
                    completedDate: new Date().toJSON()
                };
                outcome = getDraftValue( 'outcome' );
                if (  outcome ) {
                    console.log( 'setting outcome to: ' + outcome );
                    u.outcome = outcome;
                }
                updated = await update( orgId, obj.details.aid, uid, 'task', obj.details.tid, u );
                if ( updated.length ) {
                    toast.success( `The task has been marked as not doing it - slacker :)`, { theme: 'dark' } );
                    // window.location.reload( false );
                }
                break;

            case 'task-reopen':
                updated = await update( orgId, obj.details.aid, uid, 'task', obj.details.tid, { status: 'Open', completedDate: '' } );
                if ( updated.length ) {
                    toast.success( `The task has been re-opened - nice work!`, { theme: 'dark' } );
                    // window.location.reload( false );
                }
                break;

            case 'submit-setup':
            case 'submit-review':
                let changes = {};
                if ( action ) {
                    Object.keys( action ).forEach( a => {
                        changes[a] = ( action[a] === '{{now}}' ) ? new Date().toJSON() : action[a];
                    } );
                }
                console.log( 'changes: ', changes );
                updated = await update( orgId, obj.details.aid, uid, 'loan', obj.details.lid, changes );
                if ( updated.length ) {
                    toast.success( `The loan has been moved forward - nice work!`, { theme: 'dark' } );
                }
                break;

            case 'release-claim':
                const sharePartners = ( org && org.sharePartners === true ) ? true : false;
                updated = await update( orgId, obj.details.aid, uid, 'contact', obj.details.cid, { claimedBy: '' }, sharePartners );
                if ( updated.length ) {
                    toast.success( `The partner has been released!`, { theme: 'dark' } );
                }
                break;

            case 'gen-pa-letter-v1':
                break;

            case 'gen-pdf':
                console.log( 'gen-pdf: ', template );
                let file;
                if ( template.pdf ) {
                    const t = allTmpls[template.pdf];
                    if ( !t ) {
                        console.log( 'Missing pdf template - aborting' );
                        return;
                    }
                    const params = {
                        user: user,
                        org: org,
                        extra: { ...extraFields }
                    };
                    
                    switch ( oType ) {
                        case 'contact':
                            params.contact = {
                                cid: o.details?.cid,
                                ...o,
                                referredBy: contacts[o.details?.referredById]
                            }
                            console.log( 'o: ', o );
                            break;

                        case 'loan': 
                            {
                                const pri = o.borrowers.find( f => f.label === 'Primary' );
                                const c = contacts[pri.cid];
                                const lp2 = user.lists.team.find( f => f.uid === o.lp2 );
                                params.contact = {
                                    ...c,
                                    referredBy: contacts[c.referredById]
                                };
                                params.loan = {
                                    ...o,
                                    buyersAgent: contacts[o.details.baId],
                                    buyersAgentTC: contacts[o.details.baTcId],
                                    listingAgent: contacts[o.details.laId],
                                    listingAgentTC: contacts[o.details.laTcId],
                                    escrow: contacts[o.details.escrowOfficerId],
                                    title: contacts[o.details.titleRepId],
                                    lp2rep: lp2
                                };
                            }
                            break;

                        case 'task':
                            {
                                const pri = o.associations[0];
                                if ( pri ) {
                                    const c = contacts[pri.cid];
                                    params.contact = {
                                        ...c,
                                        referredBy: contacts[c.referredById]
                                    };

                                    const l = loans[pri.lid];
                                    if ( l ) {
                                        const lp2 = user.lists.team.find( f => f.uid === l.lp2 );
                                        params.loan = {
                                            ...l,
                                            buyersAgent: contacts[l.baId],
                                            buyersAgentTC: contacts[l.baTcId],
                                            listingAgent: contacts[l.laId],
                                            listingAgentTC: contacts[l.laTcId],
                                            escrow: contacts[l.escrowOfficerId],
                                            title: contacts[l.titleRepId],
                                            lp2rep: lp2
                                        };
                                    }
                                }
                            }
                            break;

                        default:
                            console.log( 'Unknown object type to generate pdf from: ' + oType );
                    }

                    console.log( 'pdf params: ', params );
                    file = await generatePdf( obj.details.aid, uid, template.filename, t.body, params, true, contacts, true, template.orientation ? template.orientation : 'portrait' );
                }
                break;

            case 'intake-purch-reset':
            case 'intake-refi-reset':
                const fields = Object.keys( obj.details ).filter( f => f.startsWith( ( at === 'intake-purch-reset' ) ? 'intakePurch' : 'intakeRefi' ) );
                const acct = user.lists.accounts.find( f => f.id === obj.details.aid );
                if ( acct?.crm?.meta?.contact?.details?.default ) {
                    const remove = {};
                    let body = `<p>${( at === 'intake-purch-reset' ) ? 'Purchase' : 'Refi'} Intake Notes - Reset on ${formatDate( new Date() )}</p><ul>`;
                    fields.forEach( f => {
                        const el = findElement( f, acct.crm.meta.contact.details.default );
                        if ( el && obj.details[f] ) {
                            body += `<li><strong>${el.label}:</strong> ${obj.details[f]}</li>`;
                            remove[f] = '';
                        }
                    } );
                    body += '</ul>';
                    // console.log( body );
                    const note = {
                        name: `${( at === 'intake-purch-reset' ) ? 'Purchase' : 'Refi'} Intake Notes Reset`,
                        details: body,
                        audio: false,
                        video: false
                    };
                    const added = await createNote( aid, uid, note, [ obj.details.cid ] );
                    await update( orgId, obj.details.aid, uid, 'contact', obj.details.cid, remove );
                    if ( added.length ) {
                        toast.success( `The Intake Notes has been reset`, { theme: 'dark' } );
                    }
                }
                break;

            default:
                console.log( 'Unknown action type: ' + at );
        }
    }, [ getDraftValue, org, orgId, aid, uid, allTmpls, contacts, loans, obj, objType, user, extraFields, addPanel ] );
    handleActionRef.current = handleAction;

    const findElement = ( fieldName, data ) => {
        for ( let section of data ) {
            for ( let row of section.body ) {
                for ( let item of row ) {
                    if ( item.db === fieldName ) {
                        return item;  // Return the item if found
                    }
                }
            }
        }
        return null;  // Return null if not found
    };

    const renderIcon = () => {
        let icon;

        switch ( objType ) {
            case 'contact':
                if ( obj?.details?.priRole === 'partner' ) {
                    icon = <BusinessIcon />;
                } else {
                    icon = <RiContactsLine />;
                }
                break;

            case 'loan':
                icon = <PaidIcon />
                break;

            case 'task':
                icon = <TaskIcon />;
                break;

            case 'leadopp':
                icon = <OfflineBoltIcon />;
                break;

            case 'note':
                icon = <NoteIcon />;
                break;

            case 'review':
                icon = <StarsIcon />;
                break;

            case 'gift':
                icon = <RedeemIcon />;
                break;

            default:
                icon = '';
        }

        return icon;
    }

    const renderDataType = ( field ) => {
        let el = null;
        let db = field.db;
        if ( !obj.details[db] && field.dbBackup ) {
            console.log( 'dbBackup: ', field.dbBackup, typeof( field.dbBackup ) );
            if ( typeof( field.dbBackup ) === 'string' ) {
                db = field.dbBackup;
            } else if ( Array.isArray( field.dbBackup ) ) {
                db = field.dbBackup.find( f => obj.details[f] );
            }
        }

        switch ( field.type ) {
            case 'text':
                el = obj.details[db];
                break;

            case 'email':
                el = <Fragment>
                        <a href={`mailto:${obj.details[db]}`}>{obj.details[db]}</a>
                        <OverlayTrigger
                            placement='top'
                            overlay={
                                <Tooltip id={`tooltip-${db}`}>
                                    Copy to clipboard
                                </Tooltip>
                            }
                        >
                            <Button variant='link' className='ms-2 p-0 tf-copy-button' onClick={ () => { navigator.clipboard.writeText( obj.details[db] ) } }><MdContentCopy /></Button>
                        </OverlayTrigger>
                    </Fragment>;
                break;

            case 'phone':
                if ( obj.details[db]?.length ) {
                    el = <Fragment>
                            <a href={`tel:${obj.details[db]}`}>{obj.details[db]}</a>
                            <OverlayTrigger
                                placement='top'
                                overlay={
                                    <Tooltip id={`tooltip-${db}`}>
                                        Copy to clipboard
                                    </Tooltip>
                                }
                            >
                                <Button variant='link' className='ms-2 p-0 tf-copy-button' onClick={ () => { navigator.clipboard.writeText( obj.details[db] ) } }><MdContentCopy /></Button>
                            </OverlayTrigger>
                        </Fragment>;
                } else {
                    el = <Fragment />
                }
                break;

            case 'contact':
                const rid = contacts[obj.details[db]];
                el = rid ? <Link to={`/contact/${rid.cid}`}>{rid.firstname} {rid.lastname}</Link> : null;
                break;

            case 'merge':
                if ( field.format ) {
                    // const t = Handlebars.compile( field.format );
                    // el = t( obj.details );
                    el = render( field.format, obj.details );
                }
                break;

            default:
                console.log( 'Unknown renderDataType:', field );
                el = obj.details[db];
        }

        return el;
    }

    const evaluateCondition = ( condition ) => {
        let showBtn = false;
        const { db, operator, value } = condition;
        const contextValue = obj.details[db];

        switch ( operator ) {
            case 'is':
                showBtn = contextValue === value;
                break;
            
            case 'not':
                showBtn = contextValue !== value;
                break;

            case 'equals':
                showBtn = contextValue == value; // Loose equality for type coercion
                break;
            
            case 'in':
                showBtn = Array.isArray( value ) && value.includes( contextValue );
                break;

            case 'valid':
            case 'exists':
                showBtn = contextValue !== undefined && contextValue !== null;
                break;

            case 'role-is':
                showBtn = ( role === value );
                break;

            default:
                console.log( 'Unknown conditional operator: ', condition );
        }

        return showBtn;
    }

    const evaluateConditionalLogic = ( conditions ) => {
        if ( conditions.operator ) {
            return evaluateCondition( conditions );
        }

        if ( conditions.logic && Array.isArray( conditions.rules ) ) {
            const results = conditions.rules.map( rule => evaluateConditionalLogic( rule ) );
            switch ( conditions.logic ) {
                case 'and':
                    return results.every( result => result );

                case 'or':
                    return results.some( result => result );

                default:
                    console.log( 'Unknown logic check: ', conditions );
            }
        }

        return false;
    }

    const showButton = ( b ) => {
        let showBtn = false;

        if ( b.conditional ) {
            showBtn = ( b.conditional.logic ) ? evaluateConditionalLogic( b.conditional ) : evaluateCondition( b.conditional );
            // switch ( b.conditional.operator ) {
            //     case 'not':
            //         if ( obj.details[b.conditional.db] !== b.conditional.value ) {
            //             showBtn = true;
            //         }
            //         break;

            //     case 'is':
            //         if ( obj.details[b.conditional.db] === b.conditional.value ) {
            //             showBtn = true;
            //         }
            //         break;

            //     case 'role-is':
            //         if ( role === b.conditional.value ) {
            //             showBtn = true;
            //         }
            //         break;

            //     default:
            // }
        } else {
            showBtn = true;
        }

        return showBtn;
    }

    useEffect( () => {
        let temps = {};

        const acct = user.lists.accounts.find( f => f.id === obj.details.aid );
        if ( acct && acct.crm && acct.crm.meta && acct.crm.meta.templates && acct.crm.meta.templates.length ) {
            acct.crm.meta.templates.forEach( t => {
                temps[t.tid] = t;
            } );
        }
        // if ( user.meta.templates && user.meta.templates.length ) {
        //     user.meta.templates.forEach( t => {
        //         temps[t.tid] = t;
        //     } );
        // }
        if ( user.templates && user.templates.length ) {
            user.templates.forEach( t => {
                temps[t.tid] = t;
            } );
        }

        setAllTmpls( temps );
    }, [ user.templates, user.lists.accounts, obj.details.aid ] );

    useEffect( () => {
        if ( layout && obj.details ) {
            if ( layout.key && layout[obj.details[layout.key]] ) {
                setView( layout[obj.details[layout.key]] );
                if ( layout[obj.details[layout.key]].title.render ) {
                    const t = Handlebars.compile( layout[obj.details[layout.key]].title.render );
                    setTitle( t( { obj: obj.details } ) );
                } else {
                    setTitle( obj.details[layout[obj.details[layout.key]].title.db] );
                }
            } else {
                setView( layout.default );
                if ( layout.default.title.render ) {
                    const t = Handlebars.compile( layout.default.title.render );
                    setTitle( t( { obj: obj.details } ) );
                } else {
                    setTitle( obj.details[layout.default.title.db] );
                }
            }
        }
    }, [ layout, obj.details ] );

    useEffect( () => {
        if ( view?.buttons?.length ) {
            setHasButtons( true );
        }
        if ( view?.dropdown?.length ) {
            setHasDropdown( true );
        }
        if ( view?.fields?.length ) {
            setHasFields( true );
        }
    }, [ view ] );

    useEffect( () => {
        if ( objType === 'task' && obj.details?.actions?.length ) {
            setHasButtons( true );
        }
    }, [ objType, obj ] );

    // useEffect( () => {
    //     if ( user.stack?.homebot && objType === 'contact' ) {
    //         setShowHomebot( true );
    //     } else {
    //         setShowHomebot( false );
    //     }
    // }, [ user.stack, objType ] );

    return (
        <Fragment>
            <Container fluid>
                <Row className='tf-contact-cv-name-container py-2 align-items-center'>
                    <Col className='fs-4'>
                        { renderIcon() }
                        <span className='ps-3 fw-bold'>{title}</span>
                    </Col>
                    {
                        showHomebot ? (
                            <Col xs='auto' className='text-end'>
                                <Dropdown>
                                    <Dropdown.Toggle
                                        as="button"
                                        className="btn p-0 border-0 bg-transparent"
                                        id="dropdown-image"
                                    >
                                        <img
                                            src={`https://tf-crm-images.s3.us-east-1.amazonaws.com/System/Homebot${obj.details.homebotId ? '' : 'Missing'}.png`}
                                            alt="Homebot"
                                            className="img-fluid rounded-circle"
                                            style={ { height: '35px', width: '35px' } }
                                        />
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        {
                                            obj.details.homebotId ? (
                                                <>
                                                    <Dropdown.Item href="#/action-1">Remove from Homebot</Dropdown.Item>
                                                </>
                                            ) : (
                                                <>
                                                    <Dropdown.Item href="#/action-1">Add as a Buyer</Dropdown.Item>
                                                    <Dropdown.Item href="#/action-2">Add as a Homeowner</Dropdown.Item>
                                                </>
                                            )
                                        }
                                    </Dropdown.Menu>
                                </Dropdown>
                            </Col>
                        ) : (
                            null
                        )
                    }
                    {
                        hasButtons ? (
                            <Col xs='auto' className='text-end'>
                                <Dropdown as={ButtonGroup}>
                                    {
                                        obj.details?.actions ? (
                                            obj.details.actions.map( ( b, idx ) => {
                                                return ( showButton( b ) ) ? <Button key={`obj-cv-button-${idx}`} className='tf-obj-button' size='sm' onClick={ () => handleClickRef.current( b ) }>{b.label}</Button> : null;
                                            } )
                                        ) : (
                                            null
                                        )
                                    }
                                    {
                                        view.buttons.map( ( b, idx ) => {
                                            if ( showButton( b ) ) {
                                                if ( b.dropdown && b.dropdown.length ) {
                                                    return (
                                                        <Dropdown>
                                                            <Dropdown.Toggle className='tf-obj-button' style={ { padding: '0.5rem', fontSize: '0.875rem', borderTopRightRadius: 0, borderBottomRightRadius: 0 } }>
                                                                {b.label}
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu>
                                                                {
                                                                    b.dropdown.map( bb => {
                                                                        if ( bb.divider === true ) {
                                                                            return <Dropdown.Divider />
                                                                        }
                                                                        return <Dropdown.Item key={`header-dropdown-${bb.template}`} onClick={ () => handleClickRef.current( bb ) }>{bb.label}</Dropdown.Item>
                                                                    } )
                                                                }
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    );
                                                } else {
                                                    return <Button key={`contact-cv-button-${idx}`} className='tf-obj-button' size='sm' onClick={ () => handleClickRef.current( b ) }>{b.label}</Button>
                                                }
                                            }
                                            return null;
                                        } )
                                    }
                                    {
                                        hasDropdown ? (
                                            <Fragment>
                                                <Dropdown.Toggle split className='tf-obj-button' id="dropdown-split-basic" />
                                                <Dropdown.Menu id="dropdown-basic-button">
                                                    {
                                                        view.dropdown.map( ( d, idx ) => {
                                                            if ( Object.keys( d ).length ) {
                                                                return ( showButton( d ) ) ? <Dropdown.Item key={`contact-cv-dropdown-${idx}`} onClick={ () => handleClickRef.current( d ) }>{d.label}</Dropdown.Item> : null;
                                                            }
                                                            return <Dropdown.Divider key={`contact-cv-dropdown-divider-${idx}`} />;
                                                        } )
                                                    }
                                                </Dropdown.Menu>
                                            </Fragment>
                                        ) : (
                                            null
                                        )
                                    }
                                </Dropdown>
                            </Col>
                        ) : (
                            null
                        )
                    }
                </Row>
                {
                    hasFields ? (
                        <Row className='py-2'>
                            {
                                view.fields.map( ( f, idx ) => {
                                    let label = f.label;
                                    if ( Object.keys( obj.details ).length && !obj.details[f.db] && f.labelBackup ) {
                                        label = f.labelBackup;
                                    }

                                    if ( f.logic ) {
                                        let show = false;

                                        eval( f.logic );

                                        if ( !show ) {
                                            return <Fragment />
                                        }
                                    }

                                    return (
                                        <Col key={`contact-cv-field-${idx}`} className='col-md-auto'>
                                            <Row><Col className='fs-8'>{label}</Col></Row>
                                            <Row><Col className='fs-7 fw-semibold'>{renderDataType( f )}</Col></Row>
                                        </Col>
                                    )
                                } )
                            }
                        </Row>
                    ) : (
                        null
                    )
                }
            </Container>
            {
                obj.duplicates?.length ? (
                    <Container fluid>
                        <Row className='tf-duplicate-contact-container align-items-center'>
                            <Col xs='auto' style={ { color: 'red' } }>Possible Duplicate(s):</Col>
                            {
                                obj.duplicates.map( ( dup ) => (
                                    <Col key={dup.cid} xs='auto'>
                                        <span className='tf-dup-name'>
                                            <Link to={ `/contact/${dup.cid}` }>{dup.name}</Link>
                                        </span>
                                        <span className='tf-dup-delete' onClick={ () => { handleModalRef.current( { modal: 'remove-dup-contact', dupCid: dup.cid } ); } }><DeleteIcon fontSize='inherit' /></span>
                                        <span className='tf-dup-merge' onClick={ () => { handleModalRef.current( { modal: 'merge-contacts', dupCid: dup.cid } ); } }><MergeIcon fontSize='inherit' /></span>
                                    </Col>
                                ) )
                            }
                        </Row>
                    </Container>
                ) : (
                    null
                )
            }
        </Fragment>
  )
}

const mapProps = ( state ) => ( {
    user: state.user,
    org: state.user.org,
    orgId: state.user.orgId,
    aid: state.user.aid,
    uid: state.user.email,
    role: state.user.role,
    settings: state.user.meta.settings,
    contacts: state.contacts.byId,
    loans: state.loans.byId
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( Header );